import React, { useState } from 'react'
import Navigator from '../../../components/common/Navigator'
import Img1 from '../../../assets/facilitationimg1.png'
import Img2 from '../../../assets/facilitationimg2.png'
import Img3 from '../../../assets/facilitationimg3.png'
import Img4 from '../../../assets/facilitationimg4.png'
import { Button, DialogModal } from '../../../components/common'
import IncubationApplyBg from '../../../assets/facilitationbg.png'

import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../../../store/authStore'
const IndustryAcademyCollaboration = () => {
  const { authenticated, roleData } = useAuthStore()
  const navigate = useNavigate()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const handleApplyNow = () => {
    if (authenticated) {
      const roleName = roleData?.name?.trim() || ''

      if (
        roleName === 'schools' ||
        roleName === 'research' ||
        roleName === 'industry_asso'
      ) {
        navigate('/departments/academic-form')
      } else {
        setIsModalOpen(true) // open modal
      }
    } else {
      navigate('/login')
    }
  }
  return (
    <div className="lg:w-11/12 lg:mx-auto mx-4  py-6 font-sans">
      <div className="">
        <Navigator
          title="Industry Academy Collaboration"
          slug="INDUSTRY_ACADEMY_COLLABORATION"
        />
        <h1 className="text-3xl font-semibold text-gray-900">
          Industry Academy Collaboration
        </h1>
        <p className="text-md text-gray-900 mb-4">
          Guiding innovators every step of the way from application to
          acceleration. Explore mentorship, funding access, space allocation,
          and government scheme navigation with dedicated support.
        </p>
        <hr className="border-t-2 border-primaryBlue mb-6" />
      </div>

      <div className="flex flex-col md:flex-row justify-between gap-8 bg-white rounded-lg">
        {/* Left Section - Text */}
        <div className="w-full md:w-7/12 flex flex-col justify-between">
          <div>
            <h2 className="text-lg font-semibold text-gray-800 mb-2">
              Fostering Innovation through Synergy: KIED’S Industry–Academia
              Collaboration Initiatives
            </h2>
            <p className="text-md text-gray-900 leading-relaxed text-justify">
              At the Kerala Institute for Entrepreneurship Development (KIED),
              we believe that true innovation and sustainable economic growth
              stem from a robust partnership between industry and academia. Our
              dedicated Industry–Academia Collaboration initiatives are designed
              to bridge the gap between theoretical knowledge and practical
              application, creating a dynamic ecosystem where ideas flourish,
              research translates into real-world solutions, and talent meets
              opportunity.
            </p>
          </div>

          <div className="flex justify-end mt-4">
            {/* <Link to="/departments/academic-form"> */}
            <Button
              onClick={handleApplyNow}
              label={'Apply Now'}
              size="common"
              outlined
              className="w-40 border border-LightGreen text-LightGreen px-6 py-3 text-sm rounded hover:bg-LightGreen hover:text-white"
            />

            {isModalOpen && (
              <DialogModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                title="Permission Required"
                className=""
                body={
                  <p className="pb-5">
                    You do not have permission to access this form.
                  </p>
                }
              />
            )}
          </div>
        </div>

        {/* Right Section - Image */}
        <div className="w-full md:w-4/12 flex justify-end">
          <img
            src={Img1}
            alt="Industry Academia Collaboration"
            className="rounded-lg object-cover w-full max-w-xl"
          />
        </div>
      </div>

      <h2 className="text-xl md:text-[36px] font-semibold text-gray-800 text-center mb-10 mt-12 md:tracking-tighter">
        Why Collaborate?
      </h2>
      <div className="bg-white border border-gray-200 rounded-xl shadow hover:shadow-lg transition duration-300 overflow-hidden mb-10 max-w-5xl mx-auto text-justify">
        <div className="flex flex-col md:flex-row p-6 ">
          <div className="w-full md:w-1/2 xs:mb-2">
            <img
              src={Img2}
              alt="For Industries"
              className="w-full h-64 object-cover rounded-lg"
            />
          </div>
          <div className="w-full md:w-1/2 lg:px-6 md:px-4">
            <h3 className="text-orange-500 text-lg font-semibold mb-3">
              For Industries
            </h3>
            <p className="text-gray-900 text-sm md:text-base leading-relaxed">
              Gain access to cutting-edge research, specialized faculty
              expertise, state-of-the-art laboratory facilities, and a pool of
              highly skilled, ready-to-deploy graduates. Address specific
              industry challenges, foster R&D, and enhance product development
              with fresh perspectives.
            </p>
          </div>
        </div>
      </div>
      <div className="bg-white border border-gray-200 rounded-xl shadow hover:shadow-lg transition duration-300 overflow-hidden mb-10 max-w-5xl mx-auto text-justify ">
        <div className="flex flex-col md:flex-row-reverse p-6">
          <div className="w-full md:w-1/2 xs:mb-2">
            <img
              src={Img3}
              alt="For Academia"
              className="w-full h-64 object-cover rounded-lg"
            />
          </div>
          <div className="w-full md:w-1/2 lg:px-6 md:px-4">
            <h3 className="text-red-500 text-lg font-semibold mb-3">
              For Academia
            </h3>
            <p className="text-gray-900 text-sm md:text-base leading-relaxed">
              Ensure curriculum relevance, provide students with practical
              exposure, facilitate applied research, and secure opportunities
              for faculty to engage in consultancy and real-world projects.
            </p>
          </div>
        </div>
      </div>
      <div className="bg-white border border-gray-200 rounded-xl shadow hover:shadow-lg transition duration-300 overflow-hidden mb-10 max-w-5xl mx-auto text-justify">
        <div className="flex flex-col md:flex-row p-6">
          <div className="w-full md:w-1/2 xs:mb-2">
            <img
              src={Img4}
              alt="For Students"
              className="w-full h-64 object-cover rounded-lg"
            />
          </div>
          <div className="w-full md:w-1/2 lg:px-6 md:px-4">
            <h3 className="text-green-600 text-lg font-semibold mb-3">
              For Students
            </h3>
            <p className="text-gray-900 text-sm md:text-base leading-relaxed">
              Benefit from internships, real-time project work, mentorship from
              industry leaders, and enhanced employability upon graduation.
            </p>
          </div>
        </div>
      </div>
      <div className="relative mt-12">
        <div
          className="hidden md:block absolute right-0 top-0 h-full w-full bg-cover bg-right rounded-xl"
          style={{
            backgroundImage: `url(${IncubationApplyBg})`,
          }}
        />

        <div className="relative z-9  rounded-xl mb-11 p-6 md:p-10 flex flex-col md:flex-row justify-between items-center max-w-6xl mx-auto">
          <div className="text-center md:text-left mb-4 md:mb-0">
            <h3 className="text-lg md:text-xl font-semibold text-gray-900">
              Shape the Future with Us
            </h3>
            <p className="text-xs md:text-sm text-gray-900 mt-1 max-w-2xl">
              Apply Now to Join a Transformative Partnership Between Industry
              and Academia. Submit Your Application Today and Be Part of a
              Powerful Collaboration Fueled by Innovation and Expertise
            </p>
          </div>
          {/* <Link to="/departments/incubation-form" className="z-10"> */}
          <Button
            outlined
            onClick={handleApplyNow}
            label="Apply Now"
            className="w-40 hover:text-white text-LightGreen hover:bg-LightGreen border-LightGreen hover:border-LightGreen text-sm"
          />
          {/* </Link> */}
        </div>
      </div>
    </div>
  )
}

export default IndustryAcademyCollaboration
